/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2025-06-05 14:08:11
 * @LastEditors: linxi
 * @LastEditTime: 2025-06-20 18:12:02
 */
import { Col, Form, Input, Modal, Progress, Row, Select, Spin } from 'antd'
import { useDispatch } from 'react-redux'
import React, { useEffect, useState } from 'react'
import { RootDispatch } from '../../../../app/store'
import { CloseOutlined } from '@ant-design/icons'
import styles from './columns.module.css'

const { Option } = Select

export const LoadingModal = (props: {
  details: any
  isModalVisible: boolean
  onOk: () => void
  onCancel: () => void
}) => {
  const [form] = Form.useForm()

  const dispatch = useDispatch<RootDispatch>()

  // 从 1% 开始
  const [percent, setPercent] = useState<number>(1);

  // 动态进度逻辑
  useEffect(() => {
    // 只有弹窗打开时才执行
    if (!props.isModalVisible) return;
    // 重置为 1%
    setPercent(1);

    // 每 40 毫秒 +1%，平滑增长
    const timer = setInterval(() => {
      setPercent((prev) => {
        // 到 100% 清除定时器
        if (prev >= 100 || JSON.stringify(props.details) != '{}'){
          clearInterval(timer);
          // 完成后自动调用成功回调
          setTimeout(() => {
            props.onOk();
          }, 300);
          return 100;
        }
        return prev + 1;
      });
    }, 40);

    // 清理定时器
    return () => clearInterval(timer);
  }, [props.isModalVisible,props.details]);

  return (
    <Modal
      title=''
      width={400}
      visible={props.isModalVisible}
      className={styles.loadingModal}
      footer={null}
      centered={true}
      maskClosable={false}
      closable={false}
      destroyOnClose
      onCancel={() => {
        props.onCancel()
      }}
      onOk={() => {
        props?.onOk()
      }}
    >
      <div className={styles.loadingModalContent}>
        <div className={styles.loadingModalTitle}>
          创建目录
        </div>
        <div className={styles.loadingModalIconContainer}>
          <CloseOutlined
            className={styles.closeIcon}
            onClick={() => {
              props.onCancel()
            }}
          />
        </div>
        <div className={styles.loadingModalProgressContainer}>
          <Progress
            percent={percent}
            type="circle"
            strokeColor="#427bff"
            showInfo={true}
            format={(percent) => `${percent}%`}
          />
        </div>
        <div className={styles.loadingModalTips}>正在创建目录中，请稍等</div>
      </div>
    </Modal>
  )
}